import { form } from '../../formState'

import { useTexts } from '../useTexts'

import { Email } from './Email'
import { Phone } from './Phone'

export function ContactInformation() {
  const texts = useTexts()
  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">
        {texts.getContactInformationTitle}
      </form.SectionTitle>

      <Phone />
      <Email />
    </form.Fieldset>
  )
}
